<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display: flex;justify-content: flex-start">
        <button-add value="添加收款记录" pathName="add-contract-pay-record" v-if="permissionCodes.indexOf('013017001') !== -1"/>
        <button-upload
          :cathUrl="uploadUrl"
          :onSuccess="onUploadSuccess"
          @getpage="getPage"
          v-if="permissionCodes.indexOf('013017004') !== -1"
          value="导入银行账单"/>
        <button-export :href="uploadTemplateUrl" download="download.xls" :beforeDownload="beforeDownload" value="导入模板下载"/>
        <button-export :href="exportUrl" download="download.xls" :beforeDownload="beforeDownload" v-if="permissionCodes.indexOf('013017003') !== -1" style="margin: 0" value="导出"/>
      </div>
      <div style="display: flex;justify-content: space-between;">
        <input-search placeholder="账单主体" @search="searchKey" />
      </div>
    </div>
    <div class="search-line" style="justify-content: flex-start">
      <el-date-picker v-model="timevalue" size="small" type="datetimerange"
                      :picker-options="pickerOptions2" range-separator="至"
                      start-placeholder="开始日期" end-placeholder="结束日期"
                      align="right" value-format="yyyy-MM-dd HH:mm:ss">
      </el-date-picker>
        <input-select selectTitle="收款方式" :selectKey="'payChannel'" :selectData="payChannelList" @search="search" style="margin-left:10px"/>
      <div style="display: flex;justify-content: flex-start">
<!--        <input-select selectTitle="开票状态" :selectKey="'invoiceStatus'" :selectData="invoiceStatusList" @search="search" style="margin-right: 10px;"/>-->
      </div>
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @changeSelection="changeSelection" @toCurrentPage="toCurrentPage" @lookOver="lookOver" @relatedBillsRow="relatedBillsRow" @invalidInvoiceRow="invalidInvoiceRow" @deleteBillRow="deleteBillRow" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :operationArr="['relatedBills', 'deleteBill', 'invalidInvoice']" />


    <el-dialog title="关联账单" :visible.sync="billVisible" width="60%">
      <table-main :selection="false" :tableHead="billTableHead" :tableData="billTableData" :pagination="false" :hasOperation="false" />
    </el-dialog>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/Finance'
  import {bus} from '../../../utils/bus'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nSuccess} from "../../../utils/notice";

  export default {
    components: {
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      ButtonAdd,
      Breadcrumb},
    name: 'contract-pay-record',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧财务',
          name: 'finance-over-view'
        }, {
          value: '收款管理'
        }],
        uploadUrl: '',
        exportUrl: '',
        uploadTemplateUrl: api.uploadTemplateUrl,
        timevalue: [],
        pickerOptions2: {
          disabledDate (time) {
            return time.getTime() > new Date(((new Date) / 1000 + 86400) * 1000)
          },
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        invoiceStatusList: [
          {
            key: '',
            label: '全部'
          }, {
            key: '0',
            label: '未开票'
          }, {
            key: '1',
            label: '已开票'
          }
        ],
        payChannelList: [{
          key: '',
          label: '全部'
        }, {
          key: '1',
          label: '微信'
        }, {
          key: '2',
          label: '支付宝'
        }, {
          key: '3',
          label: '银行转账'
        }, {
          key: '4',
          label: '现金'
        }, {
          key: '5',
          label: '其他'
        }],
        tableHead: [{
          prop: 'payer',
          label: '账单主体'
        }, {
          prop: 'money',
          label: '收款金额(元)'
        }, {
          prop: 'payChannelText',
          label: '收款方式'
        }, {
          isLooking: true,
          label: '关联账单'
        }, {
          prop: 'bankSerialNo',
          label: '流水号'
        }, {
          prop: 'operator',
          label: '经办人'
        }, {
          prop: 'payTime',
          label: '收款时间'
        }, {
          prop: 'memo',
          label: '备注'
        }, {
          prop: 'outTradeStateText',
          label: '收款状态'
        }],
        tableData: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        selectionArr: [],
        requestData: {
          searchKey: '',
          payChannel: '',
          invoiceStatus: '',
          startTime: '',
          endTime: ''
        },


        billVisible: false,
        billTableHead: [{
          prop: 'billNo',
          label: '账单编号'
        }, {
          prop: 'paymentItemName',
          label: '收款项名称',
        }, {
          prop: 'money',
          label: '账单金额(元)',
        }, {
          prop: 'memo',
          label: '账单区间'
        }],
        billTableData: [],
      }
    },
    created () {
      this.uploadUrl = api.importReceivePayment
      this.permissionCodes = bus.global.permissionCodes
      this.getPage()
    },
    activated() {
      this.getPage()
    },
    methods: {
      onUploadSuccess (data) {
        if (data.retCode == 1) {
          nSuccess('导入成功')
          this.pageSize = 10
          this.pageNum = 1
          this.requestData.searchKey = ''
          this.getPage()
        } else {
          errorHandler('导入失败')(data)
        }
      },
      beforeDownload () {
        this.exportUrl = `${api.exportReceivePayment}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&invoiceStatus=${this.requestData.invoiceStatus}&payChannel=${this.requestData.payChannel}&startTime=${this.requestData.startTime}&endTime=${this.requestData.endTime}`
      },
      getPage () {
        if (this.timevalue) {
          this.requestData.startTime = this.timevalue[0] || ''
          this.requestData.endTime = this.timevalue[1] || ''
        } else {
          this.requestData.startTime = ''
          this.requestData.endTime = ''
        }
        let reqData = this.requestData
        reqData.pageNum = this.pageNum
        reqData.pageSize = this.pageSize
        this.$axios.post(api.getReceivePaymentPage, reqData)
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data.list
              data.map(v => {
                v.code = v.outTradeNo
                if (v.isCancel === '1') {
                  v.outTradeStateText = '已作废'
                } else {
                  v.outTradeStateText = '正常'
                }
                if (v.bills.length !== 0 && v.isCancel !== '1') {
                  v.allowInvalid = 'allow'
                }
                if (v.payChannel === '1') {
                  v.payChannelText = '微信'
                } else if (v.payChannel === '2') {
                  v.payChannelText = '支付宝'
                } else if (v.payChannel === '3') {
                  v.payChannelText = '银行转账'
                } else if (v.payChannel === '4') {
                  v.payChannelText = '现金'
                } else if (v.payChannel === '5') {
                  v.payChannelText = '其他'
                }
                if (v.invoiceStatus === '0') {
                  v.invoiceStatusText = '未开票'
                } else if (v.invoiceStatus === '1') {
                  v.invoiceStatusText = '已开票'
                }
              })
              this.total = res.data.data.total
              this.tableData = data
            }
          })
          .catch(errorHandler('获取信息失败'))
      },
      search (v) {
        this.pageNum = 1
        this.requestData[v.key] = v.value
        this.getPage()
      },
      searchKey (v) {
        this.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },
      toCurrentPage (code) {
        this.$router.push({
          path: `/add_contract_pay_record_current/${code}`
        })
      },
      relatedBillsRow (data) {
        this.$router.push({
          path: `/record_related_bills/${data.code}`
        })
      },
      invalidInvoiceRow (data) {
        this.$confirm('是否确认作废此收款记录？', "温馨提示", {
          type: "warning"
        })
          .then(() => {
            let code = data.code
            this.$axios.post(`${api.cancelReceivePaymentByCodes}`, {
              outTradeNo: code
            })
              .then(res => {
                nSuccess('操作成功')
                this.getPage();
              })
              .catch(errorHandler("操作失败"));
          })
          .catch(() => {
            console.log("操作删除");
          });
      },
      deleteBillRow (data) {
        this.$confirm('是否确认删除此收款记录？', "温馨提示", {
          type: "warning"
        })
          .then(() => {
            let code = data.code
            this.$axios.post(`${api.deleteReceivePaymentByCodes}`, [code])
              .then(res => {
                nSuccess('删除成功')
                this.getPage();
              })
              .catch(errorHandler("删除失败"));
          })
          .catch(() => {
            console.log("取消删除");
          });
      },
      // 查看关联账单
      lookOver (data) {
        this.billVisible = true
        this.billTableData = data.bills
      },
    },
    watch: {
      timevalue (val) {
        this.getPage()
      }
    }
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>

<style lang="less">
  .el-input--small .el-input__inner {
    line-height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/view/Finance/InvestmentFinance/contractPayRecord.vue